export default __webpack_public_path__ + "search-examples-search-ui-and-maps-sdk-thumbnail-480-3bad84967753aa2f3cc15798d47292c5.webp";